import styled from 'styled-components'

import { colors } from '../../constants'
import { mediaQuery } from '../utils'

export const Confirmation = styled.div`
    min-width: 500px;
    text-align: left;

    ${mediaQuery.mobile(`
    min-width: 100%;
  `)}
`

export const Header = styled.div`
    color: ${colors.bluedarkest};
    font-weight: bold;
    font-size: 28px;
    overflow: hidden;
    white-space: nowrap;
    padding: 2px;
    margin-left: 10px;
`

export const Divider = styled.div`
    border-bottom: solid;
    width: 100%;
    border-width: ${(props) => props.borderWidth};
    border-color: grey;
`

export const Content = styled.div`
    color: ${colors.grey};
    font-weight: bold;
    font-size: 17px;
    overflow: hidden;
    white-space: nowrap;
    padding: 2px;
    margin: 10px;
    margin-bottom: 15px;
`

export const Buttons = styled.div`
    color: ${colors.grey};
    font-weight: bold;
    font-size: 17px;
    float: right;
    padding: 2px;
    margin: 6px;
    margin-right: 8px;
    margin-top: 8px;
`
